module.exports = __webpack_public_path__ + "static/img/75081D_2_3_R_20180513_fit.3e9b4de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/75081D_2_3_R_20180513_fit.png
// module id = /O4Q
// module chunks = 0